const defaultConfig = {
    language: "vi",
    availableLanguage: ["vi", "en"],
    apiURL: "https://us-central1-dating-app-53f63.cloudfunctions.net/app/api",
    // apiURL : "http://192.168.1.73:5000/dating-app-53f63/us-central1/app/api",
    baseURL: "http://cms.godate.me",
    secretToken: '7*&%$&J',
    firebase: {
        apiKey: "AIzaSyBaDmmg4MrApjPQo_iY4iCeq9lK6nGY8_k",
        authDomain: "dating-app-53f63.firebaseapp.com",
        databaseURL: "https://dating-app-53f63.firebaseio.com",
        projectId: "dating-app-53f63",
        storageBucket: "dating-app-53f63.appspot.com",
        messagingSenderId: "129389780726",
        appId: "1:129389780726:web:36a8e609722daafb40d6d7"
      },
    brandName: "CMS GoDate",
}

export default defaultConfig